CountryAPIService = ($http, $q, $location, cache) ->
  fromJapan: ->
    fromJapan = cache.get("fromJapan")
    delay = $q.defer()
    unless fromJapan
      # Task) add fake_ip to query parameter for SBPS testing
      # https://tr.ygo.jp/redmine/issues/10966
      params =
        fake_ip: $location.search()?.fake_ip
      $http.get('/api/geoip.json', params: params).then(
        (resp) ->
          # data.country can be null/undefined when user still not accept Term of Use
          fromJapan = resp.data.country?.country_code2 is 'JP'
          cache.put("fromJapan", fromJapan)
          delay.resolve fromJapan
      ,
        (error) ->
          delay.resolve null
      )
    else
      delay.resolve fromJapan
    delay.promise

CountryAPIService.$inject = [
  '$http'
  '$q'
  '$location'
  'cache'
]

module.exports = CountryAPIService



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/components/remote-api/country-api-service.coffee